// Helpers de fecha/formato compartidos por las pestañas de /admin/recolecciones
// (Monitoreo, Retiros y Planificación). Extraídos de adminRecolecciones.jsx al
// dividir la vista en tabs; sin lógica de negocio, solo presentación.
import i18n from "../../../i18n/index.js";
import { parseYmd } from "../../../api/recolecciones";

export const DOW_SHORT = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];
export const DOW_LONG = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
export const MONTH_SHORT = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

export function capitalizar(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function formatLargo(ymdStr) {
  const d = parseYmd(ymdStr);
  return `${capitalizar(i18n.t(DOW_LONG[d.getDay()]))}, ${d.getDate()} de ${i18n.t(MONTH_SHORT[d.getMonth()])} ${d.getFullYear()}`;
}

// Variante para el navegador de día en teléfono: a 360px la versión larga
// ("Domingo, 9 de ago 2026") se corta con puntos suspensivos. Se acorta el día
// de la semana a tres letras para que el AÑO quepa siempre — sin año la vista
// no decía en ningún lado en qué año estabas.
export function formatDiaCorto(ymdStr) {
  const d = parseYmd(ymdStr);
  const dow = capitalizar(DOW_LONG[d.getDay()]).slice(0, 3);
  return `${dow} ${d.getDate()} ${MONTH_SHORT[d.getMonth()]} ${d.getFullYear()}`;
}

export function horaDe(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

// Extrae "HH:MM" de un string (ISO o "HH:MM") para mostrar en tablas.
export function hhmm(v) {
  if (!v) return null;
  const m = String(v).match(/(\d{2}:\d{2})/);
  return m ? m[1] : null;
}

// Primer retiro REAL de una parada (mínimo por fecha). `pickups[0]` no sirve:
// buildEjecucionIndex conserva el orden de llegada del back, no el cronológico,
// y en multi-retiro el primero del array puede ser cualquiera.
export function primerPickup(pickups) {
  if (!pickups?.length) return null;
  let min = null;
  for (const pk of pickups) {
    if (!pk?.date) continue;
    if (!min || new Date(pk.date) < new Date(min.date)) min = pk;
  }
  return min ?? pickups[0];
}

export function iniciales(nombre) {
  return (nombre || "")
    .split(" ")
    .map((p) => p[0])
    .filter(Boolean)
    .join("")
    .slice(0, 2)
    .toUpperCase();
}
